import ChatBox from "components/chat-bot/ChatBox";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm, useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { setBotLogoName, setAvtarLogoName } from "redux/counterSlice";
import * as myconst from "../../constants"
import { toast } from "react-toastify";

type configurationData = {
    botName: String
    initialMessage: String
    botLogo: String
    avatarLogo: String
    headerColor: String
    questionBackgroundColor: String
    answerBackgroundColor: String
    fontType: String
    fontSize: Number
}

const fontSizeList = [
    { name: "8" }, { name: "9" }, { name: "10" }, { name: "11" }, { name: "12" }, { name: "14" }, { name: "16" }, { name: "18" }, { name: "20" }, { name: "22" }, { name: "24" }, { name: "26" }, { name: "28" }
]

const ConfigurationBot = ({ handleNext, methods }: any) => {

    const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
    const dispatch = useDispatch();
    const botLogoName = useSelector((state: any) => state.counter.botLogoName);
    const avtarLogoName = useSelector((state: any) => state.counter.avtarLogoName);
    const botRef: any = useRef(null);
    const avtartRef: any = useRef(null);
    // useEffect(() => {
    //     const errorFields = Object.keys(errors);
    //     if (errorFields.length > 0) {
    //         const errorField = errorFields[0];
    //         const fieldElement = document.querySelector(`input[name=${errorField}]`);
    //         if (fieldElement) {
    //             (fieldElement as HTMLElement)?.focus();
    //         } else {
    //             console.warn(`Field with name ${errorField} not found`);
    //         }
    //     }
    // }, [errors])
    // const {
    //     register,
    //     handleSubmit,
    //     setValue,
    //     formState: { errors },
    //     getValues,
    //     watch
    // } = useForm({
    //     // defaultValues: {
    //     //     botName: "",
    //     //     initialMessage: "",
    //     //     // botLogo: {},
    //     //     // avatarLogo: {},
    //     //     headerColor: "#F2F2F2",
    //     //     questionBackgroundColor: "",
    //     //     answerBackgroundColor: "",
    //     //     fontSize: ""
    //     // }
    // })



    const botName = watch("botName")
    const initialMessage = watch("initialMessage")
    const headerColor = watch("headerColor")
    const questionBackgroundColor = watch("questionBackgroundColor")
    const answerBackgroundColor = watch("answerBackgroundColor")
    const fontSize = watch("fontSize")
    const botLogo = watch("botLogo")
    const avatarLogo = watch("avatarLogo")
    // setValue("description", description)

    const manipulateBase64Data = async (base64Data: string) => {
        return new Promise((resolve, reject) => {
            const base64Index = base64Data.indexOf('base64');
            if (base64Index !== -1) {
                resolve(base64Data?.slice(base64Index + 7));
            } else {
                resolve(base64Data);
            }
        });
    };

    const getBase64 = (file: any) => {
        return new Promise(async (resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onload = async () => {
                const base64Data: any = fileReader.result;
                try {
                    const modifiedBase64Data = await manipulateBase64Data(base64Data);
                    resolve(modifiedBase64Data);
                } catch (error) {
                    reject(error);
                }
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
            fileReader.readAsDataURL(file);
        });
    };

    const getFormErrorMessage = (name: string) => {
        return (
            errors[name] && (
                <small className="p-error">{errors[name]?.message?.toString()}</small>
            )
        )
    }

    const handleNextButton = async () => {
        let isValid: boolean = false;
        isValid = await trigger(['organization_name', 'organization_url', 'botName', 'tagline', 'initialMessage']);

        if (isValid) {
            handleNext();
        } else {
            const errorFields = Object.keys(errors);
            if (errorFields.length > 0) {
                const errorField = errorFields[0];
                const fieldElement = document.querySelector(`input[name=${errorField}]`);
                if (fieldElement) {
                    (fieldElement as HTMLElement)?.focus();
                } else {
                    console.warn(`Field with name ${errorField} not found`);
                }
            }
        }
    }
    console.log("organization_name", getValues('organization_name'))
    return (
        <>
            <div className="step-preview-wrap">
                <div className='stepper-main'>
                    <div className='stepper-form'>
                        <div className='stepper-wrapper'>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">Organization Name<i>*</i></label>
                                    <InputText
                                        {...register("organization_name", {
                                            required: {
                                                value: true,
                                                message: "Organization name is required",
                                            },
                                        })}
                                        style={{ border: errors.organization_name ? '1px solid #EC292E' : '' }}
                                        onChange={e => { setValue("organization_name", e.target.value); clearErrors("organization_name") }}
                                    />
                                    {getFormErrorMessage("organization_name")}
                                </div>
                                <div className='form-col'>
                                    <label className="form-label">Organization URL<i>*</i></label>
                                    <InputText
                                        {...register("organization_url", {
                                            required: {
                                                value: true,
                                                message: "Organization url",
                                            },
                                        })}
                                        style={{ border: errors.organization_url ? '1px solid #EC292E' : '' }}
                                        onChange={e => { setValue("organization_url", e.target.value); clearErrors("organization_url") }}
                                    />
                                    {getFormErrorMessage("organization_url")}
                                </div>
                            </div>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">Title<i>*</i></label>
                                    <InputText
                                        {...register("botName", {
                                            required: {
                                                value: true,
                                                message: "Title is required",
                                            },
                                            maxLength: {
                                                value: 35,
                                                message: "Title must not exceed 35 characters",
                                            }
                                        })}
                                        style={{ border: errors.botName ? '1px solid #EC292E' : '' }}
                                        onChange={e => { setValue("botName", e.target.value); clearErrors("botName") }}
                                    />
                                    {getFormErrorMessage("botName")}
                                </div>
                                <div className='form-col'>
                                    <label className="form-label">Tagline<i>*</i></label>
                                    <InputText
                                        {...register("tagline", {
                                            required: {
                                                value: true,
                                                message: "Tagline is required",
                                            },
                                            maxLength: {
                                                value: 35,
                                                message: "Tagline must not exceed 35 characters",
                                            },
                                        })}
                                        style={{ border: errors.tagline ? '1px solid #EC292E' : '' }}
                                        onChange={e => { setValue("tagline", e.target.value); clearErrors("tagline") }}
                                    />
                                    {getFormErrorMessage("tagline")}
                                </div>
                            </div>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">Initial Message<i>*</i></label>
                                    <InputText
                                        {...register("initialMessage", {
                                            required: {
                                                value: true,
                                                message: "Initial message is required",
                                            },
                                        })}
                                        style={{ border: errors.initialMessage ? '1px solid #EC292E' : '' }}
                                        onChange={e => { setValue("initialMessage", e.target.value); clearErrors("initialMessage") }}
                                    />
                                    {getFormErrorMessage("initialMessage")}
                                </div>
                                <div className='form-col'>
                                    <label className="form-label">Font Size</label>
                                    <div>
                                        <Controller
                                            name="fontSize"
                                            control={methods.control}
                                            rules={{
                                                required: "Size is required"
                                            }}
                                            render={({ field }) => (
                                                <Dropdown
                                                    {...field}
                                                    id="yourDropdownId"
                                                    options={fontSizeList}
                                                    style={{ border: errors.fontSize ? '1px solid #EC292E' : '' }}
                                                    value={field.value}
                                                    optionLabel="name"
                                                    onChange={(e) => setValue("fontSize", e.target.value, { shouldValidate: true })}
                                                    placeholder="Select size"
                                                    className={`bot-dropdown`}
                                                />
                                            )}
                                        />
                                    </div>
                                    {getFormErrorMessage("fontSize")}
                                </div>
                            </div>
                            <div className='form-row'>
                                {/* <div className='form-col'>
                                    <label className="form-label">Bot Logo</label>
                                    <div className="form-field-wrap">
                                        <input
                                            onChange={async (e: any) => {
                                                if (e.target.files[0]) {
                                                    if (myconst.imageTypes.includes(e.target.files[0].type)) {
                                                        const base64Code: any = await myconst.fileToBase64(e.target.files[0])
                                                        const correctBase64 = await myconst.manipulateBase64Data(base64Code);
                                                        setValue("botLogo", correctBase64);
                                                        dispatch(setBotLogoName(e?.target?.files[0]?.name))
                                                    } else {
                                                        toast.error("File is not supported", {
                                                            style: {
                                                                backgroundColor: '#F1F1F1', // Grey background
                                                            }
                                                        })
                                                        botRef.current.value = ""
                                                    }
                                                }
                                            }
                                            }
                                            type="file"
                                            accept=".jpg,.png,.webp,.jpeg"
                                            ref={botRef}
                                            id="botLogo"
                                            className="d-none"
                                        />
                                        <button type="button" className="file-btn" onClick={() => botRef.current.click()}>Choose File</button>
                                        <span className="file-label" title={botLogoName}>{botLogoName === "" ? "No file Chosen" : botLogoName}</span>
                                    </div>
                                </div> */}
                                <div className='form-col'>
                                    <label className="form-label">Avatar Logo</label>
                                    <div className="form-field-wrap">
                                        <input
                                            onChange={async (e: any) => {
                                                if (e.target.files[0]) {
                                                    if (myconst.imageTypes.includes(e.target.files[0].type)) {
                                                        const base64Code: any = await myconst.fileToBase64(e.target.files[0])
                                                        const correctBase64 = await myconst.manipulateBase64Data(base64Code);
                                                        setValue("avatarLogo", correctBase64);
                                                        dispatch(setAvtarLogoName(e.target?.files[0]?.name))
                                                    } else {
                                                        toast.error("File is not supported", {
                                                            style: {
                                                                backgroundColor: '#F1F1F1', // Grey background
                                                            }
                                                        })
                                                        avtartRef.current.value = ""
                                                    }
                                                }
                                            }
                                            }
                                            accept=".jpg,.png,.webp,.jpeg"
                                            type="file"
                                            ref={avtartRef}
                                            id="avatarLogo"
                                            className="d-none"
                                        />
                                        <button type="button" className="file-btn" onClick={() => avtartRef.current.click()}>Choose File</button>
                                        <span className="file-label" title={avtarLogoName}>{avtarLogoName === "" ? "No file Chosen" : avtarLogoName}</span>
                                    </div>
                                </div>
                                <div className='form-col'>
                                    <label className="form-label">Answer Background Color</label>
                                    <div className="form-field-wrap color-container">
                                        <div className="color-palette">
                                            <input
                                                type="color"
                                                {...register("answerBackgroundColor", {
                                                })}
                                                style={{ border: errors.answerBackgroundColor ? '1px solid #EC292E' : '' }}
                                            />
                                        </div>
                                        <span className="file-label">{getValues("answerBackgroundColor")}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">Header Color</label>
                                    <div className="form-field-wrap color-container">
                                        <div className="color-palette">
                                            <input
                                                type="color"
                                                defaultValue={"red"}
                                                {...register("headerColor", {
                                                })}
                                                style={{ border: errors.headerColor ? '1px solid #EC292E' : '' }}
                                            />
                                        </div>
                                        <span className="file-label">{getValues("headerColor")}</span>
                                    </div>
                                </div>
                                <div className='form-col'>
                                    <label className="form-label">Question Background Color</label>
                                    <div className="form-field-wrap color-container">
                                        <div className="color-palette">
                                            <input
                                                type="color"
                                                {...register("questionBackgroundColor", {
                                                })}
                                                style={{ border: errors.questionBackgroundColor ? '1px solid #EC292E' : '' }}
                                            />
                                        </div>
                                        <span className="file-label">{getValues("questionBackgroundColor")}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='stepper-footer'>
                        <div className='stepper-wrapper stepper-wrapper-ft'>
                            <div className='stepper-footer-inner'>
                                <div className='stepper-footer-left'></div>
                                <div className='stepper-footer-right'>
                                    <button type="button" className="outline-active-btn" onClick={() => handleNextButton()}>Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="preview-section">
                    <div className="preview-header">
                        <h4>Preview</h4>
                    </div>
                    <ChatBox
                        isPreview={"isPreview"}
                        botName={getValues("botName")}
                        tagline={getValues("tagline")}
                        initialMessage={getValues("initialMessage")}
                        botLogo={getValues("botLogo")}
                        avatarLogo={getValues("avatarLogo")}
                        headerColor={getValues("headerColor")}
                        questionBackgroundColor={getValues("questionBackgroundColor")}
                        answerBackgroundColor={getValues("answerBackgroundColor")}
                        fontSize={getValues("fontSize")?.name}
                        chatHeight={true}
                    />
                </div>
            </div>
        </>
    )
}

export default ConfigurationBot
